import Vue from "vue";
import {CURRENCIES} from "@/modules/common/constants/currency";

const amountWithCurrency = Vue.filter("amountWithCurrency", (value, currency, locale, fixedPointLength = null, additionalOptions = {}) => {
  if (locale === 'keys' || locale === 'pseudo') {
    locale = 'en'
  }
  if(fixedPointLength !== null) {
    value = parseFloat(value).toFixed(fixedPointLength)
  }
  
  // Fix for currencies with 0 decimal digits in Spanish locale
  // Ensure thousand separators are shown even for amounts < 10,000
  const currencyInfo = CURRENCIES[currency];
  const options = { style: 'currency', currency: currency, ...additionalOptions };
  
  if (locale === 'es' && currencyInfo?.decimal_digits === 0 && additionalOptions.useGrouping !== false) {
    options.useGrouping = true;
  }
  
  return Intl.NumberFormat(locale, options).format(value)
});

const toCurrency = Vue.filter("currency", value => {
  if(!value) {
    return value
  }
  return CURRENCIES[value].symbol_native;
});

const toCurrencyName = Vue.filter("currencyName", value => {
  return CURRENCIES[value].name;
});

export default {
  amountWithCurrency,
  toCurrency,
  toCurrencyName,
}
